import React from 'react'
import { getWizardV2State } from '../../wizard-v2/wizardService';
import WizardNightsButton from '../../wizard-v2/components/WizardNightsButton';
import Switch from '../../../components/Switch';
import { createPortal } from 'react-dom';

const NightsStepDesktop = ({
  onNightClick,
  form,
  weekendsDisabled,
  onChangeWeekendsOnly,
  onContinueClick,
}) => {
  const stepConfig = getWizardV2State().nightsStep;
  const footerPortal = document.getElementById('wizard-next-button');

  const getNightsToShow = () => {
    const nights = [];
    for (let index = 2; index <= stepConfig.maxNights; index++) {
      nights.push(index);
    }

    return nights;
  }

  const nightsToShow = getNightsToShow();

  return (
    <>
      <div className="wizard-step">
        <div className="heading-large text-primary">{stepConfig.title}</div>
        <div className="slide-in-bottom">
          <div className="wizard-step__options wizard-nights-step">
            {nightsToShow.map((night) => (
              <WizardNightsButton
                key={night}
                label={night}
                active={form.nights.includes(night)}
                onClick={() => onNightClick(night)}
              />
            ))}
          </div>
          <div className={`mt-6 flex gap-4 justify-center items-center slide-in-bottom animation-delay-${nightsToShow.length * 50}`}>
            <div className="body-medium font-medium text-tertiary">{stepConfig.subTitle}</div>
            <Switch
              label={stepConfig.weekendsOnlyText}
              value={form.weekendsOnly}
              onChange={onChangeWeekendsOnly}
            />
          </div>
        </div>
      </div>

      {footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={onContinueClick}>
          {stepConfig.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </>
  )
}

export default NightsStepDesktop
